import { render, staticRenderFns } from "./OrderShare.vue?vue&type=template&id=66bc7a9e&"
import script from "./OrderShare.vue?vue&type=script&lang=js&"
export * from "./OrderShare.vue?vue&type=script&lang=js&"
import style0 from "./OrderShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports